import { cn } from '@/lib/utils'
import { CatalogTag } from '@/lib/actModes'

interface ActChipsProps {
  options: CatalogTag[]
  selected: string[]
  onToggle: (key: string) => void
  disabled?: boolean
}

/**
 * The move he taps instead of writing an essay. A structured pick is what makes
 * "which of these actually works for me" answerable a month from now.
 */
export default function ActChips({ options, selected, onToggle, disabled }: ActChipsProps) {
  return (
    <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
      {options.map(option => {
        const isSelected = selected.includes(option.key)
        return (
          <button
            key={option.key}
            type="button"
            disabled={disabled}
            onClick={() => onToggle(option.key)}
            className={cn(
              'flex items-center gap-2 text-left px-3 py-2.5 rounded-xl border-2 transition min-h-[44px] text-sm',
              isSelected
                ? 'border-primary bg-primary/10 font-medium'
                : 'border-border hover:border-primary/50 hover:bg-accent',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
            aria-pressed={isSelected}
          >
            <span className="text-lg shrink-0">{option.emoji}</span>
            <span>{option.label}</span>
          </button>
        )
      })}
    </div>
  )
}
